import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  Alert,
} from '@mui/material';
import Iconify from 'src/components/iconify';
import { Controller } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const PayrollHeader = ({ handleNavigateBack, error, submitSuccess, companyInfo, control, setWeekEndingsDate }) => {
  const [weekEndDay, setWeekEndDay] = useState(null);
  const [disabledDays, setDisabledDays] = useState([]);

  useEffect(() => {
    getDateSettings();
  }, []);

  const getDateSettings = async () => {
    const data = await getRequest(endpoints.accounting.payroll.generate_payroll.create_settings);
    if (data) {
      const weekEndDay = data?.week_end_day;
      setWeekEndDay(weekEndDay);
      const allDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
      const disabled = allDays.filter(day => day !== weekEndDay);
      setDisabledDays(disabled);
    }
  };
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px',
        }}
      >
        <Typography variant="h4">Generate Payroll</Typography>
        <Button
          onClick={handleNavigateBack}
          variant="contained"
          className="dark-button"
          startIcon={<Iconify icon="material-symbols:arrow-back" />}
        >
          Back
        </Button>
      </Box>

      {/* Alert Messages */}
      {error && (
        <Alert severity="error" sx={{ mx: 2, mb: 2 }}>
          {error}
        </Alert>
      )}
      {submitSuccess && (
        <Alert severity="success" sx={{ mx: 2, mb: 2 }}>
          Operation completed successfully!
        </Alert>
      )}

      {/* Company Info Card */}
      <Card sx={{ mb: 3, mx: 2 }}>
        <CardContent>
          <Grid container spacing={2}>
            {companyInfo?.map((item, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Box sx={{ display: 'flex', mb: 1 }}>
                  <Typography variant="subtitle2" sx={{ width: '50%', color: 'text.secondary' }}>
                    {item.header}
                  </Typography>
                  <Typography variant="body2" sx={{ width: '50%' }}>
                    {item.value}
                  </Typography>
                </Box>
                <Divider sx={{ my: 1.5 }} />
              </Grid>
            ))}
          </Grid>
          <Box mt={2} mb={2} display="grid" gridTemplateColumns={{ xs: '1fr', sm: '1fr 1fr' }} gap={2}>
            <Controller
              name="week_endings"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <DatePicker
                  label="Week endings"
                  {...field}
                  value={weekEndDay} // Set the default value from the fetched API data
                  onChange={(newDate) => {
                    field.onChange(newDate);
                    setWeekEndingsDate(newDate);
                  }}
                  format="MM-dd-yyyy"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!error,
                      helperText: error?.message,
                    },
                  }}
                  shouldDisableDate={(date) => {
                    const day = date.getDay(); // Get the day of the week (0: Sunday, 1: Monday, ..., 6: Saturday)
                    const disabledDaysMap = {
                      0: "Sunday",
                      1: "Monday",
                      2: "Tuesday",
                      3: "Wednesday",
                      4: "Thursday",
                      5: "Friday",
                      6: "Saturday",
                    };
                    const selectedDay = disabledDaysMap[day];
                    return disabledDays.includes(selectedDay); // Disable the days that are not the selected week_end_day
                  }}
                />
              )}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
export default PayrollHeader;
